import { Checkbox } from "source/shared/components"
import AutoSizeTextInput from "source/giving/components/AutoSizeTextInput"
import { CharacterCounter } from "source/giving/components/CharacterCounter"
import { MEMO_LINE_LENGTH_LIMIT } from "../constants"
import { Memo } from "../types"

interface MemoLineProps {
  memo: Memo
  onTextChange: (text: string) => void
  onCheckboxChange: (checked: boolean) => void
}

export function MemoLine({
  memo,
  onTextChange,
  onCheckboxChange,
}: MemoLineProps) {
  const characterCounterId = "donation-memo-character-counter"

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === "Enter") {
      e.preventDefault() // prevent Enter key
    }
  }

  const handleBlur = () => {
    const trimmedText = memo.text.replace(/\n/g, " ").trim()
    onTextChange(trimmedText)
  }

  const label: unknown = <span className="fw-500">Add a memo</span>

  if (!memo.eligible) {
    return null
  }

  return (
    <div>
      <Checkbox
        id="donation-memo-checkbox"
        checked={memo.checked}
        label={label as string}
        onChange={(event) => {
          onCheckboxChange(event.target.checked)
        }}
      />
      {memo.checked && (
        <>
          <div className="mt-1">
            <AutoSizeTextInput
              id="donation-memo-input"
              value={memo.text}
              maxLength={MEMO_LINE_LENGTH_LIMIT}
              aria-label="Memo"
              onBlur={handleBlur}
              onChange={(event) => {
                onTextChange(event.target.value)
              }}
              onKeyDown={handleKeyDown}
              aria-describedby={characterCounterId}
            />
            <CharacterCounter
              id={characterCounterId}
              value={memo.text}
              maxLength={MEMO_LINE_LENGTH_LIMIT}
              showAfter={Math.floor(MEMO_LINE_LENGTH_LIMIT * 0.8)}
              className="mt-1"
            />
          </div>
          <p id="donation-memo-disclaimer" className="c-tint2 fs-4 mt-1 mb-0">
            {memo.disclaimer}
          </p>
        </>
      )}
    </div>
  )
}
